import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TabItem, TabNavigation } from './models/tab-navigation.interfaces';

@Component({
  selector: 'idp-tab-navigation',
  templateUrl: './tab-navigation.component.html',
  styleUrls: ['./tab-navigation.component.scss']
})
export class TabNavigationComponent implements TabNavigation {
  @Input() selectedTabIndex = 0;
  @Input() tabList: TabItem[] = [];
  @Output() selectedTab = new EventEmitter<TabItem>();

  notifyTabSelection(event: Event, tabItem: TabItem, index: number): void {
    event.preventDefault();
    this.setSelectedTab(index);
    this.selectedTab.emit(tabItem);
  }

  setSelectedTab(index: number): void {
    this.selectedTabIndex = index;
  }
}
